import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { useLanguage } from "context/LanguageContext";
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

function Information() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    {messages.information.frontTitleTop}
                    <br />
                    {messages.information.frontTitleBottom}
                  </>
                }
                description={messages.information.frontDescription}
              />
              <RotatingCardBack
                image={bgBack}
                title={messages.information.backTitle}
                description={messages.information.backDescription}
                action={{
                  type: "internal",
                  route: "/construccion",
                  label: messages.information.backAction,
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon={messages.information.cards[0].icon}
                  title={messages.information.cards[0].title}
                  description={messages.information.cards[0].description}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon={messages.information.cards[1].icon}
                  title={messages.information.cards[1].title}
                  description={messages.information.cards[1].description}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon={messages.information.cards[2].icon}
                  title={messages.information.cards[2].title}
                  description={messages.information.cards[2].description}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon={messages.information.cards[3].icon}
                  title={messages.information.cards[3].title}
                  description={messages.information.cards[3].description}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
